/* AURA Studio RC1.1 — Premium Navigation Behavior */
(() => {
  const root = document.body;
  if (!root) return;

  const isHome = document.body.classList.contains('template-index') || location.pathname === '/';
  if (isHome) root.classList.add('aura-rc-transparent-header');

  const update = () => {
    root.classList.toggle('aura-rc-scrolled', window.scrollY > 20);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });

  // Hover intent class for mega menu polish
  document.querySelectorAll('.shopify-section-group-header-group details').forEach(details => {
    details.addEventListener('toggle', () => {
      document.body.classList.toggle('aura-rc-menu-open', details.open);
    });
  });

  // Keyboard escape closes open header details
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.shopify-section-group-header-group details[open]').forEach(d => d.removeAttribute('open'));
    document.body.classList.remove('aura-rc-menu-open');
  });
})();
